export default __webpack_public_path__ + "static/media/UserPhoto.5c75f163.svg";